const es = {
  header: {
    badge: "Guía Oficial de BotMix",
    title: "Centro de Reportes y Análisis Comercial de Atenciones",
    summary:
      "La vista de Reportes de Atenciones te permite auditar de manera integral cada conversación sostenida en BotMix, medir el rendimiento comercial y operativo de tu equipo de asesores, filtrar en cascada por Marca, Embudo, Conexión y Etapas, y analizar métricas de conversión con el Gráfico Visual de Embudo (Funnel Chart), métricas de Lead Time por etapa y exportación a Excel.",
  },
  sections: [
    {
      id: "filtros_cascada",
      title: "1. Filtros Jerárquicos en Cascada (Secuencia de Negocio)",
      description:
        "Filtros estructurados que respetan la jerarquía comercial de tu empresa.",
      items: [
        {
          id: "filtro_marca",
          title: "Filtro por Marca",
          definition:
            "Selecciona la Marca comercial de la empresa. Al elegir una marca, el sistema filtra y activa automáticamente los Embudos (tableros) y las Conexiones asociadas exclusivamente a esa marca.",
          importance:
            "Es el punto de partida fundamental para empresas que gestionan múltiples líneas de negocio, marcas blancas o sedes diferentes.",
        },
        {
          id: "filtro_embudo",
          title: "Filtro por Embudo (Tablero Kanban)",
          definition:
            "Selecciona el flujo comercial o tablero de trabajo vinculado a la marca seleccionada. Al seleccionarlo, se cargarán el Gráfico Visual de Embudo, las Etapas (Lanes) y las sub-etiquetas correspondientes.",
          importance:
            "Permite aislar procesos de ventas específicos (ej. 'Venta Directa', 'Soporte VIP', 'Renovaciones').",
        },
        {
          id: "filtro_conexion",
          title: "Filtro por Conexión (WhatsApp)",
          definition:
            "Permite acotar la consulta a un número o línea de WhatsApp específico vinculado al embudo o marca activa.",
        },
        {
          id: "filtro_etapa",
          title: "Filtro por Etapa (Lane) y Sub-etiquetas",
          definition:
            "Filtra los tickets que se encuentran o han pasado por una fase específica del embudo (ej. 'Nuevo Lead', 'Calificado', 'Cerrado / Perdido') y sus sub-etiquetas de acción.",
        },
        {
          id: "filtro_fechas",
          title: "Rango de Fechas (Inicio y Fin)",
          definition:
            "Establece el periodo de análisis. Por defecto, el sistema precarga las atenciones del mes en curso para ofrecer visibilidad inmediata.",
        },
      ],
    },
    {
      id: "metricas_kpi",
      title: "2. Métricas y KPIs Comerciales en Vivo",
      description:
        "Indicadores cuantitativos calculados al instante con base en los filtros seleccionados.",
      items: [
        {
          id: "kpi_total_atenciones",
          title: "Total de Atenciones",
          definition:
            "Número total de tickets registrados en el periodo y filtros actuales.",
        },
        {
          id: "kpi_monto_total",
          title: "Monto Total Comercial",
          definition:
            "Sumatoria de los valores asignados a las oportunidades en la moneda configurada de la empresa (USD $).",
          importance:
            "Refleja el valor monetario total en cartera o transaccionado dentro del periodo.",
        },
        {
          id: "kpi_tasa_conversion",
          title: "Tasa de Conversión (%)",
          definition:
            "Porcentaje de tickets finalizados exitosamente con venta respecto al total de oportunidades atendidas.",
        },
        {
          id: "kpi_ticket_promedio",
          title: "Ticket Promedio",
          definition:
            "Valor comercial promedio de las oportunidades registradas (Monto total dividido entre tickets con valor).",
        },
      ],
    },
    {
      id: "grafico_embudo",
      title: "3. Gráfico Visual de Embudo (Funnel Chart) y Velocidad (Lead Time)",
      description:
        "Representación visual interactiva en pipeline progresivo del avance de oportunidades, montos monetarios y tiempos de maduración.",
      items: [
        {
          id: "lectura_embudo",
          title: "Tarjetas de Etapas y Métricas Financieras",
          definition:
            "Cada tarjeta refleja el volumen de leads en esa fase, el monto acumulado en la moneda del sistema y el tiempo promedio de permanencia (Lead Time en horas o días).",
          importance:
            "Permite cuantificar con precisión el valor económico detenido en cada fase del ciclo de ventas.",
        },
        {
          id: "tasas_conversion_perdida",
          title: "Chips de Conversión y Deserción Inter-Etapa",
          definition:
            "Entre etapas consecutivas, se muestra el porcentaje de paso efectivo (ej. ➔ 67%) y la tasa de deserción o abandono (ej. -33%).",
          importance:
            "Identifica de inmediato en qué fase del embudo se están perdiendo los prospectos más valiosos.",
        },
        {
          id: "filtrado_interactivo",
          title: "Filtrado Interactivo al Clic",
          definition:
            "Al hacer clic en cualquier etapa del embudo, la tabla inferior se filtra automáticamente mostrando únicamente las atenciones de esa fase. Un segundo clic o el botón 'Ver todo el embudo' restablece la vista general.",
        },
      ],
    },
    {
      id: "tabla_atenciones",
      title: "4. Tabla de Atenciones Detallada",
      description:
        "Listado granular de cada conversación con trazabilidad operativa y comercial enriquecida.",
      items: [
        {
          id: "col_etapa_kanban",
          title: "Etapa Kanban",
          definition:
            "Insignia con el color identificador y nombre de la etapa actual en la que se encuentra el ticket en el tablero.",
        },
        {
          id: "col_lead_time",
          title: "Lead Time en Etapa",
          definition:
            "Tiempo transcurrido desde que el ticket ingresó a su etapa actual hasta el cierre o tiempo presente.",
        },
        {
          id: "col_valor_oportunidad",
          title: "Valor de la Oportunidad",
          definition:
            "Monto comercial asignado al prospecto o ticket expresado en la moneda oficial de la empresa.",
        },
        {
          id: "col_ultimo_mensaje",
          title: "Último Mensaje Recibido",
          definition:
            "Muestra un extracto limpio del último mensaje recibido en el ticket. Al posar el cursor sobre el texto, un tooltip desplegará el mensaje completo sin desbordar la tabla.",
        },
        {
          id: "col_tiempo_soporte",
          title: "Tiempo Total de Atención",
          definition:
            "Duración cronometrada desde que el ticket fue abierto hasta que el asesor cerró la atención.",
        },
        {
          id: "col_acciones",
          title: "Historial e Ingreso Directo",
          definition:
            "Permite consultar los registros de auditoría del ticket (icono de reloj) o abrir la conversación en el chat en una nueva pestaña (icono de flecha).",
        },
        {
          id: "btn_exportar",
          title: "Exportar a Excel",
          definition:
            "Descarga una hoja de cálculo formateada con todos los registros filtrados incluyendo Etapa, Lead Time y Valores comerciales, lista para análisis ejecutivo.",
        },
      ],
    },
  ],
};
const en = {
  "header": {
    "badge": "BotMix Official Guide",
    "title": "Reports and Business Analysis Center — Customer Service",
    "summary": "The Reports view allows comprehensive auditing of every conversation in BotMix, evaluating agent productivity, cascading filters by Brand, Funnel, Connection, and Stages, analyzing conversion rates with the visual Funnel Chart, measuring Stage Lead Time, and exporting data to Excel."
  },
  "sections": [
    {
      "id": "filtros_cascada",
      "title": "1. Hierarchical Cascading Filters",
      "description": "Structured filters following your company's business hierarchy.",
      "items": [
        {
          "id": "filtro_marca",
          "title": "Brand Filter",
          "definition": "Selects the business brand, dynamically populating associated funnels and connections."
        },
        {
          "id": "filtro_embudo",
          "title": "Funnel Filter (Kanban Board)",
          "definition": "Filters by commercial pipeline to analyze specific stage conversions."
        },
        {
          "id": "filtro_conexion",
          "title": "Channel/Connection Filter",
          "definition": "Isolates conversations by WhatsApp line or social network."
        }
      ]
    },
    {
      "id": "grafico_embudo",
      "title": "2. Visual Funnel Chart and Lead Time",
      "description": "Conversion metrics and stage progression speed.",
      "items": [
        {
          "id": "funnel_conversion",
          "title": "Funnel Conversion Rate",
          "definition": "Visualizes drop-off and conversion percentages across Kanban stages."
        },
        {
          "id": "lead_time",
          "title": "Stage Lead Time",
          "definition": "Average duration leads remain in each stage before moving forward."
        },
        {
          "id": "export_excel",
          "title": "Excel Data Export",
          "definition": "Exports full filtered datasets with timestamps and metrics."
        }
      ]
    }
  ]
};
const pt = {
  "header": {
    "badge": "Guia Oficial da BotMix",
    "title": "Centro de Relatórios e Análise Comercial de Atendimentos",
    "summary": "A visão de Relatórios permite auditar todas as conversas na BotMix, medir produtividade da equipe, filtrar em cascata por Marca, Funil, Conexão e Etapas, além de visualizar o Gráfico de Funil (Funnel Chart), métricas de Lead Time e exportação para Excel."
  },
  "sections": [
    {
      "id": "filtros_cascada",
      "title": "1. Filtros Hierárquicos em Cascata",
      "description": "Filtros alinhados à estrutura comercial da empresa.",
      "items": [
        {
          "id": "filtro_marca",
          "title": "Filtro por Marca",
          "definition": "Seleciona a marca comercial, ativando funis e conexões vinculadas."
        },
        {
          "id": "filtro_embudo",
          "title": "Filtro por Funil (Kanban)",
          "definition": "Filtra por pipeline de vendas específico."
        },
        {
          "id": "filtro_conexion",
          "title": "Filtro por Conexão",
          "definition": "Isola atendimentos por número de WhatsApp ou canal."
        }
      ]
    },
    {
      "id": "grafico_embudo",
      "title": "2. Gráfico Visual de Funil e Lead Time",
      "description": "Taxas de conversão e tempo de permanência nas etapas.",
      "items": [
        {
          "id": "funnel_conversion",
          "title": "Conversão do Funil",
          "definition": "Visualização gráfica da passagem de leads entre etapas."
        },
        {
          "id": "lead_time",
          "title": "Lead Time por Etapa",
          "definition": "Tempo médio que os contatos permanecem em cada fase."
        },
        {
          "id": "export_excel",
          "title": "Exportação para Excel",
          "definition": "Download completo das métricas em planilha."
        }
      ]
    }
  ]
};
const fr = {
  "header": {
    "badge": "Guide Officiel BotMix",
    "title": "Centre de Rapports et d'Analyse Commerciale",
    "summary": "La vue Rapports permet d'analyser l'ensemble des échanges BotMix, de mesurer la performance des conseillers, d'appliquer des filtres en cascade par Marque, Tunnel, Connexion et Étapes, et d'étudier les conversions avec le graphique d'entonnoir et l'export Excel."
  },
  "sections": [
    {
      "id": "filtros_cascada",
      "title": "1. Filtres Hiérarchiques en Cascade",
      "description": "Filtres respectant la structure de votre entreprise.",
      "items": [
        {
          "id": "filtro_marca",
          "title": "Filtre par Marque",
          "definition": "Sélectionne la marque commerciale et met à jour les canaux associés."
        },
        {
          "id": "filtro_embudo",
          "title": "Filtre par Tunnel",
          "definition": "Cible un tableau Kanban spécifique pour analyser les conversions."
        },
        {
          "id": "filtro_conexion",
          "title": "Filtre par Connexion",
          "definition": "Isole les échanges par ligne WhatsApp ou réseau social."
        }
      ]
    },
    {
      "id": "grafico_embudo",
      "title": "2. Graphique d'Entonnoir et Lead Time",
      "description": "Taux de transformation et rapidité de progression.",
      "items": [
        {
          "id": "funnel_conversion",
          "title": "Taux de Conversion",
          "definition": "Visualisation de l'avancement des prospects dans le tunnel."
        },
        {
          "id": "lead_time",
          "title": "Lead Time par Étape",
          "definition": "Temps moyen passé dans chaque phase."
        },
        {
          "id": "export_excel",
          "title": "Export Excel",
          "definition": "Téléchargement des données détaillées en tableur."
        }
      ]
    }
  ]
};
const ar = {
  "header": {
    "badge": "دليل BotMix الرسمي",
    "title": "مركز التقارير والتحليل التجاري للمحادثات",
    "summary": "تتيح لك شاشة التقارير تدقيق كل محادثة في BotMix، وقياس أداء الوكلاء، والتصفية المتسلسلة حسب العلامة التجارية والمسار والقناة والمراحل، وتحليل معدلات التحويل بمخطط القمع وتصدير البيانات إلى Excel."
  },
  "sections": [
    {
      "id": "filtros_cascada",
      "title": "1. الفلاتر الهرمية المتسلسلة",
      "description": "فلاتر تتبع التسلسل التجاري للمؤسسة.",
      "items": [
        {
          "id": "filtro_marca",
          "title": "تصفية بالعلامة التجارية",
          "definition": "اختيار العلامة لتفعيل المسارات والقنوات المرتبطة بها تلقائيًا."
        },
        {
          "id": "filtro_embudo",
          "title": "تصفية بالمسار (لوحة Kanban)",
          "definition": "تحديد مسار المبيعات لتحليل تقدم العملاء."
        },
        {
          "id": "filtro_conexion",
          "title": "تصفية بالقناة / الاتصال",
          "definition": "عزل المحادثات حسب رقم WhatsApp أو القناة."
        }
      ]
    },
    {
      "id": "grafico_embudo",
      "title": "2. مخطط القمع ومدة البقاء (Lead Time)",
      "description": "مقاييس التحويل وسرعة تقدم الصفقات.",
      "items": [
        {
          "id": "funnel_conversion",
          "title": "معدل تحويل القمع",
          "definition": "تمثيل بياني لنسب انتقال العملاء بين مراحل البيع."
        },
        {
          "id": "lead_time",
          "title": "متوسط البقاء في المرحلة",
          "definition": "الوقت المستغرق في كل مرحلة قبل التقدم."
        },
        {
          "id": "export_excel",
          "title": "تصدير إلى Excel",
          "definition": "تنزيل كامل البيانات المفلترة في ملف إكسل."
        }
      ]
    }
  ]
};

export const REPORTS_HELP_DATA = { es, en, pt, fr, ar };
